import './LandProductDrawer.css'
import 'antd/dist/reset.css'
import React from 'react'
import { Drawer, Button, Tabs } from 'antd'
import { RightOutlined } from '@ant-design/icons'
import LandProductPanel from './LandProductPanel'

export const productDrawerHeight = 500

export default class LandProductDrawer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {}

  render() {
    return (
      <Drawer
        height={productDrawerHeight}
        title={null}
        placement="top"
        closeIcon={null}
        open={this.props.open}
        rootStyle={{ position: 'fixed', top: '10vh', zIndex: 100 }}
        styles={{
          header: {
            paddingLeft: '8vw',
            paddingRight: '8vw',
            paddingTop: '0px',
            paddingBottom: '0px',
          },
          body: {
            paddingLeft: '8vw',
            paddingRight: '8vw',
            paddingTop: '0px',
            paddingBottom: '0px',
          },
        }}
      >
        <div className="LandProductNavigate">
          <div className="LandProductNavigateName">产品分类</div>
          <Button
            color="green"
            variant="text"
            style={{
              fontSize: 16,
              fontWeight: 'bold',
              fontFamily: 'MyCustomizedFont',
            }}
            icon={<RightOutlined style={{ fontSize: 16 }} />}
            iconPosition="end"
            onClick={() => {
              this.props.handleClose()
              this.viewProductList()
            }}
          >
            查看所有产品
          </Button>
        </div>

        <Tabs
          items={[
            {
              key: 'customer',
              label: '按行业公司',
              children: <LandProductPanel entry="customer" {...this.props} />,
            },
            {
              key: 'variety',
              label: '按品种',
              children: <LandProductPanel entry="variety" {...this.props} />,
            },
          ]}
          style={{ fontFamily: 'MyCustomizedFont' }}
        />
      </Drawer>
    )
  }

  viewProductList = () => {
    this.props.history.push('/product_list')
  }
}
